import { t } from '../i18n';

export function Pagination({ currentPage, totalPages, onPageChange }: { currentPage: number, totalPages: number, onPageChange: (p: number) => void }) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  const delta = 2; // Number of pages to show around current page

  // Always show first page
  if (totalPages > 0) pages.push(1);

  // Calculate range around current page
  let left = Math.max(2, currentPage - delta);
  let right = Math.min(totalPages - 1, currentPage + delta);

  // Add ellipsis before range if needed
  if (left > 2) {
    pages.push('...');
  }

  // Add range
  for (let i = left; i <= right; i++) {
    pages.push(i);
  }

  // Add ellipsis after range if needed
  if (right < totalPages - 1) {
    pages.push('...');
  }

  // Always show last page if > 1
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return (
    <nav aria-label={t('pagination.label')} class="sw-pagination-nav">
      <ul class="pagination justify-content-center">
        <li class={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button class="page-link" onClick={() => onPageChange(1)} aria-label={t('pagination.first')}>&laquo;&laquo;</button>
        </li>
        <li class={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button class="page-link" onClick={() => onPageChange(Math.max(1, currentPage - 1))} aria-label={t('pagination.previous')}>&laquo;</button>
        </li>

        {pages.map((p, idx) => (
          <li key={idx} class={`page-item ${p === currentPage ? 'active' : ''} ${p === '...' ? 'disabled' : ''}`}>
            {p === '...' ? (
              <span class="page-link">...</span>
            ) : (
              <button class="page-link" onClick={() => onPageChange(p as number)}>{p}</button>
            )}
          </li>
        ))}

        <li class={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button class="page-link" onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))} aria-label={t('pagination.next')}>&raquo;</button>
        </li>
        <li class={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button class="page-link" onClick={() => onPageChange(totalPages)} aria-label={t('pagination.last')}>&raquo;&raquo;</button>
        </li>
      </ul>
    </nav>
  );
}
